import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { CalendarService } from 'src/Services/API';

export const useRemoveAgencyCalendar = (
  config?: UseMutationOptions<
    void,
    Error,
    { agencyId: string; calendarObjectId: string; brandCode: string },
    unknown
  >
) => {
  return useMutation(async params => {
    return await CalendarService.calendarControllerRemoveCalendar(params);
  }, config);
};
